export const downloadTrackingNames = {
  'passthrough-overall': 'Metric: Pass-through Rate',
  'apps-for-one-hire': 'Metric: Applications per Hire',
  'passthrough-by-stage': 'Graph: Pass-through Rate by Stage',
  'yield-calculations': 'Graph: Applications per X Hires',
  'passthrough-report-table': 'Table: Pass-through Data',
  'gender-survey-completion': 'Graph: Submission Rate for Gender',
  'race-survey-completion': 'Graph: Submission Rate for Race',
  'gender-distribution': 'Graph: Gender Distribution of Apps',
  'gender-by-stage': 'Graph: Gender Distribution by Stage',
  'race-distribution': 'Graph: Racial Distribution of Apps',
  'race-by-stage': 'Graph: Racial Distribution by Stage',
  'gender-data-table': 'Table: Gender Data',
  'race-data-table': 'Table: Race Data',
  'drop-off-average': 'Metric: Drop-off Rate',
  'drop-off-average-benchmark': 'Metric: Drop-off Benchmark',
  'higher-proportion-drop-offs': 'Graph: Drop-off Rate by Stage (Bar)',
  'most-drop-offs': 'Graph: Drop-off Rate by Stage (Donut)',
  'dropoff-report-table': 'Table: Drop-off Data',
  'applications-received': 'Metric: Applications Received',
  'overall-pass-through-rate': 'Metric: Pass-through Rate',
  'hires-made': 'Metric: Hires Made',
  'time-to-hire-benchmark': 'Benchmark: Time to Hire',
  'offer-acceptance-rate-benchmark': 'Benchmark: Offer Acceptance Rate',
  'drop-off-rate-benchmark': 'Benchmark: Drop-off Rate',
  'exec-gender-distribution': 'Graph: Gender Distribution',
  'source-distribution': 'Graph: Source Distribution',
  female_applied: 'Metric: % Female Applications',
  female_hired: 'Metric: % Female Hires',
  male_applied: 'Metric: % Male Applications',
  male_hired: 'Metric: % Male Hires',
  'gender-representation-by-stage': 'Graph: Gender Distribution by Stage',
  'female-vs-male-passthrough-rate': 'Graph: Gender Pass-through by Stage',
  'gender-report-table': 'Table: Gender Data',
  number_of_hires: 'Metric: Number of Hires',
  avg_acceptance_rate: 'Metric: Offer Acceptance Rate',
  median_hire_time: 'Metric: Time to Hire',
  current_open_offers: 'Metric: Open Offers',
  'offer-acceptance-rate-vs-benchmark': 'Benchmark: Offer Acceptance',
  'time-to-hire-vs-benchmark': 'Benchmark: Time to Hire',
  'gender-distribution-of-hires': 'Graph: Gender Distribution of Hires',
  'hire-source-category': 'Graph: Source Distribution of Hires',
  'hiring-report-table': 'Table: Offer Data',
  'top-sources-by-application': 'Graph: Source Distribution of Apps',
  'top-sources-by-hire': 'Graph: Source Distribution of Hires',
  general_applications: 'Metric: % Apps from General Sources',
  general_hired: 'Metric: % Hires from General Sources',
  niche_applications: 'Metric: % Apps from Niche Sources',
  niche_hired: 'Metric: % Hires from Niche Sources',
  free_applications: 'Metric: % Apps from Free Sources',
  free_hired: 'Metric: % Hires from Free Sources',
  paid_applications: 'Metric: % Apps from Paid Sources',
  paid_hired: 'Metric: % Hires from Paid Sources',
  'inbound-report-table': 'Table: Inbound Data',
  'outbound-top-sources-by-application': 'Graph: Source Distribution of Apps',
  'outbound-top-sources-by-hire': 'Graph: Source Distribution of Hires',
  prospecting_applications: 'Metric: % Apps from Prospecting',
  prospecting_hired: 'Metric: % Hires from Prospecting',
  agencies_applications: 'Metric: % Apps from Agencies',
  agencies_hired: 'Metric: % Hires from Agencies',
  'outbound-report-table': 'Table: Outbound Source Data',
  'overall-top-sources-by-application': 'Graph: Source Distribution of Apps',
  'overall-top-sources-by-hire': 'Graph: Source Distribution of Hires',
  'overall-report-table': 'Table: Overall Source Data',
  'requisition-applicants': 'Recent Applications',
  'requisition-gender': 'Graph: Gender Distribution of Apps',
  'requisition-source': 'Graph: Source Distribution of Apps',
  'applicants-table': 'Table: Application Data',
};
